/**
 * Toast notifications, stacked bottom-right. Purely presentational: their
 * timing runs on setTimeout rather than game ticks because a toast should
 * keep dismissing on schedule even if the game loop is paused.
 */

const TOAST_MS = 4000;
const MAX_VISIBLE = 4;

export interface Toasts {
  show(title: string, body: string): void;
}

export function createToasts(root: HTMLElement): Toasts {
  return {
    show(title, body) {
      const toast = document.createElement('div');
      toast.className = 'toast';
      toast.setAttribute('role', 'status');

      const t = document.createElement('div');
      t.className = 'toast__title';
      t.textContent = title;
      const b = document.createElement('div');
      b.className = 'toast__body';
      b.textContent = body;
      toast.append(t, b);

      root.append(toast);
      while (root.children.length > MAX_VISIBLE) {
        root.firstElementChild?.remove();
      }
      window.setTimeout(() => toast.remove(), TOAST_MS);
    },
  };
}
